<template>
    <div class="card">
        <!-- after loading completes, show the forms -->
        <div class="grid justify-content-around m-5">
            <!-- <dynamic-form-steps /> -->
            <dynamic-form-attributes class="col-12 md:col-8"  :user="user"/>
            <!-- Steps Progress Here -->
            <dynamic-form-steps class="col-12 md:col-4" />
        </div>
    </div>
</template>

<script setup>
import DynamicFormSteps from '../components/DynamicFormSteps.vue';
import DynamicFormAttributes from '../components/DynamicFormAttributes.vue';

import { onMounted, defineProps, provide, onBeforeUnmount, ref, computed } from 'vue';
import { useAnswerStore } from '../../answers/store';
import { useAssessmentFormStore } from '../store';
import GlobalRequest from '@/api/global-request';
import { useStore } from 'vuex';
import { showToast } from '@/helpers/toast-handler';

const formStore = useAssessmentFormStore();

const props = defineProps({
    userId: {
        type: [Number, String],
        required: true,
    },
    assessmentCode: {
        type: String,
        required: true,
    },
});

const answerStore = useAnswerStore();
const store = useStore();

provide('answerStore', answerStore);
provide('formStore', formStore);
provide('userId', props.userId);

const user = ref({})

const company_id = computed(() => {
    return store.getters['auth/userCompanyId']?.id;
});

onMounted(async () => {

    //console.log('userId', props.userId)

    GlobalRequest
        .getRequest(`v2/admin/users/${props.userId}?company_id=${company_id.value}`)
        .then((response) => {
            user.value = {}
            if (response.statusCode === 200) {
                if (Object.hasOwn(response, 'data')) {
                    user.value = response.data
                }
            }
        }).catch((err) => {
        showToast({}, err?.data?.message ?? 'Something went wrong');
        });

    // initially load the create answer form for an assessment step using the assessmentCode and the company id
    await formStore.initiateAnswerForm(props.assessmentCode);
    // check if its a user profile assessment
    if (props.assessmentCode === 'user_profile') {
        // if yes then load the last submitted user assessment
        await loadExistingUserProfile();
    }
});

// this function loads answers of the last submitted user profile assessment by a particular user
const loadExistingUserProfile = async () => {
    // first make sure to load all answers first to get all the userprofile answers submitted by that particular userid
    await answerStore.getLatestUserProfileAnswer(props.userId);
};

onBeforeUnmount(() => {
    // reset the states data
    formStore.resetAssessmentForm();
});
</script>
